/* eslint-disable react/no-danger */
import React from "react";
import { Avatar } from "@mui/material";
import moment from 'moment';
import statusLabel from "../../../utils/statusLabelMaintenance";
import { i18n } from "../../../translate/i18n";
import numberToCurrency from "../../../utils/numberToCurrency";

const styles = {
  timelineItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  avatar: {
    width: 50,
    height: 50,
    fontSize: 13
  },
  timelineItemHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
    backgroundColor: '#f4f7fc',
    padding: '20px 10px 20px 10px',
    borderRadius: 8,
    marginBottom: 10,
  },
  timelineItemHeaderName: {
    width: '100%',
    marginLeft: 10,
    fontSize: '1rem',
  },
  timelineItemBody: {
    marginLeft: 60
  },
  timelineItemHeaderNameDate: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  timelineItemDate: {
    color: "#888c91",
    fontSize: '0.8rem',
  },
  timelineItemAuthor: {
    // display: 'flex',

  },
  author: {
    fontWeight: 'bold',
    marginRight: 5,
  }
}

const printColorfulStatus = (status) => (
  statusLabel(status).title === i18n.t('maintenancesStatusLabel.title4') ?
  `<b style="color: #457CDA">
      ${i18n.t('maintenancesStatusLabel.title3')}
  </b>`
  :
  `<b style="color: ${statusLabel(status).color}">
      ${statusLabel(status).title}
  </b>`
); // Condição para não mostrar status Pendente na Timeline

const timelineContent = (timeline) => {
  switch (timeline.type) {
    case 'changeIdentifier':
      return `${i18n.t('maintenanceTimelineContent.change_identifier')} ${timeline.changeIdentifier?.from ? timeline.changeIdentifier.from : i18n.t('maintenanceTimelineContent.empty_value_1') } ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeIdentifier?.to ? timeline.changeIdentifier.to : i18n.t('maintenanceTimelineContent.empty_value_1')}`;
    case 'changeDescription':
      return `${i18n.t('maintenanceTimelineContent.change_description')} ${timeline.changeDescription?.from ? timeline.changeDescription.from : i18n.t('maintenanceTimelineContent.empty_value_2')} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeDescription?.to ? timeline.changeDescription.to : i18n.t('maintenanceTimelineContent.empty_value_2')}`;
      case 'changeValue':
        return `${i18n.t('maintenanceTimelineContent.change_value')} ${timeline.changeValue?.from ? numberToCurrency(timeline.changeValue.from) : '0,00'} ${i18n.t('maintenanceTimelineContent.to')} R$ ${timeline.changeValue?.to ? numberToCurrency(timeline.changeValue.to) : '0,00'}`;
    case 'changeCompany':
      return `${i18n.t('maintenanceTimelineContent.change_company')} ${timeline.changeCompany?.from ? timeline.changeCompany.from : i18n.t('maintenanceTimelineContent.empty_value_2')} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeCompany?.to ? timeline.changeCompany.to : i18n.t('maintenanceTimelineContent.empty_value_2')}`;
    case 'changeStatus':
      return <span dangerouslySetInnerHTML={{ __html: `${i18n.t('timelineContent.status')} ${printColorfulStatus(timeline.changeStatus.from)} ${i18n.t('timelineContent.to')} ${printColorfulStatus(timeline.changeStatus.to)}` }} />
    case 'creation':
      return `${i18n.t('maintenanceTimelineContent.created')}`
    case 'changeSendToMaintenanceDate':
      return `${i18n.t('maintenanceTimelineContent.change_send_to_maintenance_date')} ${timeline.changeSendToMaintenanceDate?.from ? i18n.t('maintenanceTimelineContent.from') + moment(timeline.changeSendToMaintenanceDate?.from).format('DD/MM/YYYY') : ''} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeSendToMaintenanceDate?.to ? moment(timeline.changeSendToMaintenanceDate.to).format('DD/MM/YYYY') : i18n.t('maintenanceTimelineContent.empty_value_1')}`
    case 'changeReturnFromMaintenanceDate':
      return `${i18n.t('maintenanceTimelineContent.change_return_from_maintenance_date')} ${timeline.changeReturnFromMaintenanceDate?.from ? i18n.t('maintenanceTimelineContent.from') + moment(timeline.changeReturnFromMaintenanceDate?.from).format('DD/MM/YYYY') : ''} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeReturnFromMaintenanceDate?.to ? moment(timeline.changeReturnFromMaintenanceDate.to).format('DD/MM/YYYY') : i18n.t('maintenanceTimelineContent.empty_value_1')}`
    case 'changeWarranty':
      return `${i18n.t('maintenanceTimelineContent.change_warranty')} ${timeline.changeWarranty?.from ? i18n.t('maintenanceTimelineContent.from') + moment(timeline.changeWarranty?.from).format('DD/MM/YYYY') : ''} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeWarranty?.to ? moment(timeline.changeWarranty.to).format('DD/MM/YYYY')  : i18n.t('maintenanceTimelineContent.empty_value_1')}`
    case 'changeExpiration':
      return `${i18n.t('maintenanceTimelineContent.change_expiration')} ${timeline.changeExpiration?.from ? i18n.t('maintenanceTimelineContent.from') + moment(timeline.changeExpiration.from).format('DD/MM/YYYY') : ''} ${i18n.t('maintenanceTimelineContent.to')} ${timeline.changeExpiration?.to ? moment(timeline.changeExpiration.to).format('DD/MM/YYYY')  : i18n.t('maintenanceTimelineContent.empty_value_1')}`
    case `addNewFile`:
      return `${i18n.t('maintenanceTimelineContent.file')} ${timeline.addNewFile.name} ${i18n.t('maintenanceTimelineContent.add_file')}`
    case `filesDeleted`:
      return `${i18n.t('maintenanceTimelineContent.file')} ${timeline.filesDeleted.name} ${i18n.t('maintenanceTimelineContent.delete_file')}`
      case `conversation`:
      return `${timeline.conversation.message}.`
    default:
      return i18n.t('timelineContent.change');
  }
}

const TimelineItem = props => {
  return (
    <div>
      {props.timeline && props.timeline.map(timeline =>
        <div style={styles.timelineItem} key={timeline._id}>
          <div style={styles.timelineItemHeader}>
            <Avatar style={styles.avatar}>{' '}</Avatar>
            <div style={styles.timelineItemHeaderName}>
              <div style={styles.timelineItemAuthor}>
                <span style={styles.author}>{timeline.author.name}</span>
                <span>{timelineContent(timeline)}</span>
              </div>
              <div style={styles.timelineItemDate}>
                {moment(timeline.createdAt).format('DD/MM/YYYY, k:mm')}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimelineItem;
